import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class AgreementSelectorView {
  uid: string = ""
  name: string = ""
  countryName: string = "Other"
  currency: string = "EUR"

  constructor(
    data: {
      uid: string
      name: string
      countryName?: string
      currency?: string
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.name = data.name
      this.countryName = data.countryName
      this.currency = data.currency || "EUR"
    }
  }
}
